module.exports = __webpack_public_path__ + "static/media/filter.d31ab3a3.svg";